import { Translate } from 'react-redux-i18n'
import { Button } from '../../../../common/html/button'
import { Element } from '../../../../common/html/element'
import EventEmitter from '../../../../helpers/EventEmitter'
import { SHOW_POPUP_BUSINESS_CONCIERGE } from '../../businessConciergeService/PopupBusinessConcierge'
import classes from './index.module.scss'

export const BlockBusinessService = () => {
  const onClick = () => {
    EventEmitter.dispatch(
      SHOW_POPUP_BUSINESS_CONCIERGE,
      'internationalPreview.BUSINESS_CONCIERGE',
    )
  }

  return (
    <Element
      style={{ backgroundColor: '#F3F3F3', borderColor: '#d5d5d5' }}
      className={classes.blockBusinessService}
    >
      <Element style={{ color: '#191D25' }} className="fw600 mb1">
        <Translate value="internationalPreview.BUSINESS_CONCIERGE" />
      </Element>
      <div style={{ marginBottom: 4 }}>
        <Translate value="internationalPreview.BUSINESS_CONCIERGE_DETAIL" />
      </div>
      <div className="dFlex justifyContentEnd">
        <Button
          label="internationalPreview.CREATE_REQUEST"
          style={{ backgroundColor: '#2C73E8', color: '#fff' }}
          className={classes.blockBusinessServiceButton}
          isI18n
          action={onClick}
        />
      </div>
    </Element>
  )
}
